// This file is generated by scripts/generate-build-info.js
// Do not edit manually.

export const buildId = "dpl_8Qg3byZL2XFKpYzr2FKF4TnkfBap" as const;
export const builtAt = "2026-11-03T21:35:43.931Z" as const;
export const vercelEnv: string | null = "preview";
export const gitCommitSha: string | null = "530b822a23861f37ac7fcfda7fd1a8bfc416093c";
export const deploymentId: string | null = "dpl_8Qg3byZL2XFKpYzr2FKF4TnkfBap";
